// extracted by mini-css-extract-plugin
export default {"contentContainer":"local-guides_contentContainer__T63pa","pageTitle":"local-guides_pageTitle__-M6ZB","articleIntro":"local-guides_articleIntro__hUwuh"};